import { Modal, Form, DatePicker } from "antd";
import { changeLoader } from "../../redux/reducers/loader";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { convertSlote } from "../../utils/helper/utils";

const Reschedule = ({ isOpen, onCancel, onOk, orderDetailData }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [orderDetail, setOrderDetail] = useState([]);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [deliveryDateErr, setDeliveryDateErr] = useState("");
  const [deliverySlots, setDeliverySlots] = useState([]);
  const [deliverySlotId, setDeliverySlotId] = useState(null);
  const [deliverySlotIdErr, setDeliverySlotIdErr] = useState(null);
  const [ timeSlotDetails, setTimeSlotDetails] = useState({openTime: "", closeTime: ""})

  useEffect(() => {
    setOrderDetail(orderDetailData);
  }, [orderDetailData]);

  useEffect(() => {
  if (isOpen && orderDetailData?.deliveryDate) {
    const d = orderDetailData?.deliveryType !== "schedule" ? dayjs(orderDetailData.deliveryDate) : dayjs();
    form.setFieldsValue({ date: d });
    setDeliveryDate(d.format("YYYY-MM-DD"));
  }
}, [isOpen, orderDetailData, form]);

  const handleDateChange = async (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : null;
    const dayName = date ? dayjs(date).format("dddd").toLowerCase() : null;
    setDeliveryDate(formattedDate);
    setDeliveryDateErr("");
    if (orderDetailData?.deliveryType === "schedule") {
      dispatch(changeLoader(true));
      try {
        let params = {
          date: formattedDate,
          day: dayName,
          order_id: orderDetail.id,
          type: "reschedule",
        };
        let response = await globalRequest(Apis.ORDERS.GET_SLOTS, "get", {}, { params: params }, true);
        let apiResponse = response?.data;
        if (response?.status === 200) {
          setDeliverySlots(apiResponse?.data?.data.slots);
        } else {
          // toast.error(apiResponse?.message);
        }
      } catch (e) {
        toast.error(e?.message);
      }
      dispatch(changeLoader(false));
    }
  };

  const fastestSlots = [30, 60, 90, 120]

  const disablePastDates = (current) => {
    // Disable dates before today
    return current && current < dayjs().startOf("day");
  };

  const handleSubmit = async (values) => {
    if (!deliveryDate) {
      setDeliveryDateErr("Date is required");
      return false;
    }

    if (orderDetailData.deliveryType === "schedule" && !deliverySlotId) {
      setDeliverySlotIdErr("Slot is required");
      return false;
    }

    let insertData = {
      order_id: orderDetailData.id,
      delivery_date: deliveryDate,
      time_slot_id: deliverySlotId ? deliverySlotId : 0,
      time_slot_details: timeSlotDetails,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.ORDERS?.RESHEDULE_ORDER;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Order has been successfully rescheduled.";
        toast.success(msg, {
          duration: 2000,
        });
        onOk();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Modal
        title="Reschedule"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={() => {
          handleSubmit();
        }}
        width={350}
        okText="Save"
        cancelText="Cancel"
      >
        <Form
          name="Cancel Order"
          layout="vertical"
          autoComplete="off"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={
            {
              // remember: true,
            }
          }
        >
          <Form.Item name="date" label={deliveryDate}>
            <DatePicker format="DD/MM/YYYY" value={deliveryDate ? dayjs(deliveryDate) : null} className="h-[39px] w-full" onChange={handleDateChange} disabledDate={disablePastDates} />
            {deliveryDateErr && <span className="text-[#ff4d4f]">{deliveryDateErr}</span>}
          </Form.Item>
        </Form>
        {orderDetailData?.deliveryType !== "schedule" ? 
          <>
            <h6 className="mb-2">Extended Time Slots</h6>
            <select
              className="w-full border rounded-lg p-3 text-sm"
              value={timeSlotDetails?.openTime || ""}
              onChange={(e) => {
                const value = e.target.value;
                setTimeSlotDetails({
                  openTime: value,
                  closeTime: value,
                });
              }}
            >
              <option value="">Select time slot</option>

              {fastestSlots.length > 0 ? (
                fastestSlots.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))
              ) : (
                <option disabled>No slots available</option>
              )}
            </select>

            {deliverySlotIdErr && (
              <span className="text-[#ff4d4f]">{deliverySlotIdErr}</span>
            )}
          </>
          :   
          <>
            <h6 className="mb-2">Available Time Slots</h6>
            <div className="grid grid-cols-2 gap-3 mb-6">
              {deliverySlots.length > 0 ? (
                deliverySlots.map((item, index) => {
                  const isActive = deliverySlotId === item.id;
                  return (
                    <div
                      key={item.id}
                      className={`w-full rounded-lg py-3 px-1.5 cursor-pointer text-center text-sm ${
                        isActive ? "bg-[#176b53] text-[#fff]" : "bg-gray-100 text-gray-500"
                      }`}
                      onClick={() => { setDeliverySlotId(item.id);
                        setTimeSlotDetails({
                          openTime: item.openTime,
                          closeTime: item.closeTime,
                        });
                      }}
                    >
                      {convertSlote(item.openTime)} - {convertSlote(item.closeTime)}
                    </div>
                  );
                })
              ) : (
                <div className="col-span-2 w-full rounded-lg py-3 px-1.5 bg-gray-100 text-gray-500 text-center">No slots available</div>
              )}
              {deliverySlotIdErr && <span className="text-[#ff4d4f]">{deliverySlotIdErr}</span>}
            </div>
          </> }
      </Modal>
    </>
  );
};
export default Reschedule;
